export default {
      id: "event-documents-header-usage",
      viewBox: "0 0 67 76",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-documents-header",
      toString: function () {
        return this.url;
      }
    }